import { createContext, useContext } from 'react'

import sanitizer from '../../../helpers/sanitizer'
import { useAuth } from '../../Shared/Contexts/AuthContext'

const GatewaysContext = createContext({})

export const useGateways = () => {
  return useContext(GatewaysContext)
}

export const GatewaysProvider = ({ children }) => {
  const { useBaseAxiosPost, useBaseAxiosGet, useBaseAxiosPut, useBaseAxiosDelete } = useAuth()

  const useSearchGateways = async ({
    filters,
    page,
    pageSize,
    sort,
    direction
  }) => {
    return await useBaseAxiosPost({
      url: '/gateways/search',
      params: {
        page: !page ? 1 : page,
        pageSize,
        sort: sort ? `${sort}:${direction}` : undefined
      },
      payload: sanitizer(filters)
    })
  }

  const useFetchGateway = async (serial) => {
    return useBaseAxiosGet({ url: `/gateways/${serial}` })
  }

  const useFetchGatewayTests = async ({ serial, page = 1, pageSize }) => {
    return await useBaseAxiosGet({
      url: `/gateways/tests/${serial}?page=${page}&pageSize=${pageSize}`
    })
  }

  const useCreateGateway = async (payload) => {
    return await useBaseAxiosPost({
      url: '/gateways',
      payload: sanitizer(payload)
    })
  }

  const useUpdateGateway = async (serial, payload) => {
    return await useBaseAxiosPut({
      url: `/gateways/${serial}`,
      payload: sanitizer(payload)
    })
  }

  const useDeleteGateway = async (serial) => {
    return await useBaseAxiosDelete({
      url: `/gateways/${serial}`
    })
  }

  const value = {
    useSearchGateways,
    useFetchGatewayTests,
    useFetchGateway,
    useCreateGateway,
    useUpdateGateway,
    useDeleteGateway
  }

  return (
    <GatewaysContext.Provider value={value}>
      {children}
    </GatewaysContext.Provider>
  )
}
